import { render } from "./App.vue?vue&type=template&id=63c9bcac"
const script = {}

import "./App.vue?vue&type=style&index=0&id=63c9bcac&lang=css"
script.render = render

export default script